import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Play SVG Icon (Player footer)
 */
export const Play: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG width="100%" height="100%" viewBox="0 0 40 40" {...props}>
    {(shadowFilter) => (
      <path
        filter={shadowFilter}
        d="M14.9765 29.3996C14.1117 29.3996 13.5 28.7316 13.5 27.654V12.2456C13.5 11.1788 14.1117 10.5 14.9765 10.5C15.3703 10.5 15.7224 10.6277 16.1365 10.8604L28.7505 18.312C29.6575 18.8615 30.0372 19.271 30.0372 19.9498C30.0372 20.6286 29.6575 21.0489 28.7505 21.5876L16.2949 28.9471C15.8097 29.238 15.4195 29.3996 14.9765 29.3996Z"
        fill={props.fill ?? 'currentColor'}
      />
    )}
  </AccessibleSVG>
)
